// extracted by mini-css-extract-plugin
export default {"moreButton":"Rl7kr2","icon":"DstSiq"};